import { render, staticRenderFns } from "./customerInfo.vue?vue&type=template&id=606bc9d6&scoped=true&"
import script from "./customerInfo.vue?vue&type=script&lang=js&"
export * from "./customerInfo.vue?vue&type=script&lang=js&"
import style0 from "./customerInfo.vue?vue&type=style&index=0&id=606bc9d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606bc9d6",
  null
  
)

export default component.exports